import * as prismicH from '@prismicio/helpers'
import { createClient } from 'services/prismic'

import Divider from 'components/Divider'
import EnquiryForm from 'components/EnquiryForm'
import Header from 'components/Header'
import LocationCard from 'components/LocationCard'
import PrismicPageHead from 'components/PrismicPageHead'
import Spacer from 'components/Spacer'
import Text from 'components/Text'

import { EnquiryFormWrapper, Locations, Root } from './contact.style'

const prismicLocationToLocationCardProps = ({ data }) => ({
  name: data.name,
  imageUrl: data.image?.url,
  locationBadge: data.location_tag,
  address: prismicH.asHTML(data.address),
  email: data.email_address,
  telephone: data.telephone_number,
  openingHours: prismicH.asHTML(data.opening_hours),
})

export default function Contact({ document, locations }) {
  return (
    <>
      <PrismicPageHead document={document} />
      <Root>
        <Header>Visit us at one of our stores</Header>
        <Spacer y={12} />
        <Locations>
          {locations.map(prismicLocationToLocationCardProps).map((props, index) => (
            <LocationCard key={index} {...props} />
          ))}
        </Locations>
      </Root>
      <Divider />
      <EnquiryFormWrapper>
        <div>
          <Header>Speak with our online team</Header>
          <Spacer y={6} />
          <Text prose>
            Our dedicated website team works from the New York store and monitor requests and messages on a daily basis.
            We aim to respond to all enquiries within 24 hours.
          </Text>
        </div>
        <EnquiryForm />
      </EnquiryFormWrapper>
      <Divider />
    </>
  )
}

export async function getServerSideProps({ previewData }) {
  const prismic = createClient({ previewData })
  const document = await prismic.getPage('contact')

  const locations = await prismic.getAllByType('location', {
    orderings: {
      field: 'my.location.position',
    },
  })

  return {
    props: {
      document,
      locations,
    },
  }
}
